import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { NavLink, Outlet, useOutletContext, useLocation, Navigate } from "react-router-dom";

function BusinessPulse() {
	const { setValue } = useForm();
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
	const {setGlobalLoading, token } = useOutletContext();
	const [data, setData] = useState([]);
	const [selectedUser, setSelectedUser] = useState(null);
	const getCurrentFinancialYear = () => {
		const today = new Date();
		const year = today.getFullYear();
		const month = today.getMonth() + 1;

		if (month >= 4) {
			return `${year} - ${year + 1}`;
		} else {
			return `${year - 1} - ${year}`;
		}
		};

	const [year, setYear] = useState(getCurrentFinancialYear());
	// const [showMenu , setShowMenu] = useState(true);
	
	const isWorkAllocationOnlyUser = Number(user?.id) === 609;
	const [showMenu, setShowMenu] = useState(!isWorkAllocationOnlyUser);

  useEffect(() => {
    const getBasicDetails = async () => {
      try {
        setGlobalLoading(true);
        const response = await axios.get(
          `${REACT_APP_API_BASE_URL}/performance/user_details`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
		setData(response.data);
		if (response.data?.user?.length > 0) {
			const defaultUser = response.data.user.find(
				(item) => item.id === user.id
				);
			const selected = defaultUser || response.data.user[0];
				setSelectedUser(selected);
				setValue("user_id", selected.id);
			}
      } catch (error) {
        console.log(error);
        setGlobalLoading(false);
      } finally {
        setGlobalLoading(false);
      }
    };
    getBasicDetails();
  }, []);
  	const canChangeUser = user?.designation_id === 1 || user?.admin === '1' || user?.id === 609;

	const availableUsers = canChangeUser
		? (data?.user || [])
		: (data?.user || []).filter(
			(item) =>
				Number(item.id) === Number(user.id) ||
				Number(item.reporting_to) === Number(user.id)
			);
	const location = useLocation();
	const isWorkAllocation = location.pathname.includes("/work_allocation");

	if (isWorkAllocationOnlyUser && (location.pathname.endsWith("/overview"))) {
		return <Navigate to="/performance/work_allocation" replace />;
		}

    return (
        <>
		<div className="container-fluid">
			<div className="row mt-2">
				<div className="d-flex justify-content-end align-items-center">
					<select className="form-select me-3" style={{ width: "130px" }} value={year} onChange={(e) => setYear(e.target.value)} disabled={isWorkAllocation}>
						<option value="2026 - 2027">2026 - 2027</option>
						<option value="2025 - 2026">2025 - 2026</option>
						<option value="2024 - 2025">2024 - 2025</option>
						<option value="2023 - 2024">2023 - 2024</option>
						<option value="2022 - 2023">2022 - 2023</option>
					</select>
				<div className="dropdown">
				<button	className="btn btn-light dropdown-toggle" type="button" 
					data-bs-toggle={availableUsers ? "dropdown" : ""}
  					disabled={!availableUsers}
				>
				{selectedUser
				? `${selectedUser.firstname} ${selectedUser.lastname}`
				: "Select User"}
				</button>
				<ul className="dropdown-menu">
				{availableUsers.map((item)=>(
				<li key={item.id}>
				<button	className="dropdown-item" onClick={()=>{
				setSelectedUser(item);
				setValue("user_id", item.id);
				}}
				>
				{item.firstname} {item.lastname}
				</button>
				</li>
				))}
				</ul>
				</div>
				</div>
			</div>
			<div className="row mt-2">
				<div className="d-flex col-md-12">
				{!isWorkAllocationOnlyUser && (	
					<span class="avatar rounded-circle bg-primary mb-2" style={{position:"absolute",zIndex:"1",margin:"-16px 0px 0px -10px"}}>
					{showMenu === true ? (
						<>
						<i class="fa-2x fa-solid fa-xmark" title="Close Menu" style={{color:"#fff"}} onClick={() => setShowMenu(false)}></i>
						</>
					):(
						<>
						<i class="fa-2x fa-solid fa-bars " title="Show Menu" style={{color:"#fff"}} onClick={() => setShowMenu(true)}></i>
						</>
					)}
					
					</span>
				)}	
					{showMenu === true && (
					<div className="col-md-2">
						<div className="card h-100">
						<div className="card-body">
							<div className="d-flex flex-column list-group settings-list">
							<NavLink to="overview" className={({ isActive }) => `py-2 px-3 ${isActive ? "active" : ""}`}>
							<i className="fa fa-server me-2"></i>Overview
							</NavLink>

							<NavLink to="clients" className={({ isActive }) => `py-2 px-3 ${isActive ? "active" : ""}`}>
							<i className="fa fa-building me-2"></i>Clients
							</NavLink>

							<NavLink to="roles" className={({ isActive }) => `py-2 px-3 ${isActive ? "active" : ""}`}>
							<i className="fa fa-briefcase me-2"></i>Roles
							</NavLink>

							<NavLink to="work_allocation" className={({ isActive }) => `py-2 px-3 ${isActive ? "active" : ""}`}>
							<i className="fa fa-calendar me-2"></i>Work Allocation
							</NavLink>
							
							<NavLink to="team_performance" className={({ isActive }) => `py-2 px-3 ${isActive ? "active" : ""}`} style={{ whiteSpace: "nowrap" }}>
							<i className="fa fa-users me-2"></i>Team&nbsp;Performance
							</NavLink>

							<NavLink to="commercial" className={({ isActive }) => `py-2 px-3 ${isActive ? "active" : ""}`}>
							<i className="fa fa-indian-rupee-sign me-2"></i>Commercial
							</NavLink>

							<NavLink to="self_generation" className={({ isActive }) => `py-2 px-3 ${isActive ? "active" : ""}`}>
							<i className="fa fa-hand-holding-dollar me-2"></i>Self Generation
							</NavLink>
						
							{/*<NavLink to="analytics" className={({ isActive }) => `py-2 px-3 ${isActive ? "active" : ""}`}>
							<i className="fa fa-chart-column me-2"></i>Analytics
							</NavLink> */}
							</div>
						</div>
					</div>
					</div>
					)}
					<div className={`${showMenu === true ? "col-md-10" : "col-md-12"} clearfix ms-1`}>
						<div className="page-content">
					<div className="content-scroll">
						<Outlet context={{ selectedUser, year, setGlobalLoading, token }} />
					</div>
				</div>
					</div>
				</div>
			</div>
		</div>
        </>
    );
}

export default BusinessPulse;